import pluralize from 'pluralize'

export const MINUTE = 60
const HOUR = MINUTE * 60
const DAY = HOUR * 24
const WEEK = DAY * 7

export const parseSeconds = (secondsToConvert, upperLevel = 'days') => {
  let remainingSeconds = secondsToConvert
  let weeks = 0
  if (upperLevel === 'weeks') {
    weeks = Math.floor(remainingSeconds / WEEK)
    remainingSeconds = remainingSeconds % WEEK
  }

  const days = Math.floor(remainingSeconds / DAY)
  remainingSeconds = remainingSeconds % DAY

  const hours = Math.floor(remainingSeconds / HOUR)
  remainingSeconds = remainingSeconds % HOUR

  const minutes = Math.floor(remainingSeconds / MINUTE)
  remainingSeconds = remainingSeconds % MINUTE

  const seconds = remainingSeconds

  return { weeks, days, hours, minutes, seconds }
}

const GOING_ONCE_UPPER_BOUND = 12
const GOING_TWICE_UPPER_BOUND = 6

const formatCountdownTime = (secondsRemaining, isTextEnabled) => {
  const { days, hours, minutes, seconds } = parseSeconds(secondsRemaining)

  if (secondsRemaining >= DAY) {
    return `${days}d ${hours}h`
  } else if (secondsRemaining >= HOUR) {
    return `${hours}h ${minutes}m`
  } else if (secondsRemaining >= MINUTE) {
    return `${minutes}m ${seconds}s`
  } else if (isTextEnabled && GOING_ONCE_UPPER_BOUND >= secondsRemaining) {
    if (secondsRemaining > GOING_TWICE_UPPER_BOUND) {
      return `GOING ONCE! - ${seconds}s`
    } else if (secondsRemaining > 0) {
      return `GOING TWICE! - ${seconds}s`
    } else {
      return 'FINALIZING...'
    }
  } else {
    return `${seconds}s`
  }
}

// TODO: remove this after pdp and dashboard are moved over to the new object return format
export const formatCountdownTimeWithText = secondsRemaining => {
  return formatCountdownTime(secondsRemaining, true)
}

// TODO: remove this after pdp and dashboard are moved over to the new object return format
export const formatCountdownTimeWithoutText = secondsRemaining => {
  return formatCountdownTime(secondsRemaining, false)
}

/**
 * Returns user friendly time string based on seconds remaining e.g.
 * For 2 days and change, it will return '2 days'
 * For 1 day and change, it will return '1 day'
 * For 23 hours and change, it will return '23 hours'
 * For 2 hrs and change, it will return '2 hours'
 * For 15 mins and change, it will return '15 mins'
 * For 1 min to 1m 59s, it will return '1 min'
 * For 1 to 59s, it will return '< 1 min'
 * -- no seconds timer
 * @param {*} secondsRemaining
 * @param upperLevel
 * @param {string} lowerLevel - The lowest level of time measurement ('days', 'hours', 'minutes').
 *
 * @returns time string
 */
export const formatPeriodTime = (
  secondsRemaining,
  upperLevel = 'days',
  lowerLevel = 'minutes'
) => {
  const { weeks, days, hours, minutes } = parseSeconds(
    secondsRemaining,
    upperLevel
  )
  const weekTerm = pluralize('week', weeks, true)
  const dayTerm = pluralize('day', days, true)
  const hourTerm = pluralize('hour', hours, true)
  const minuteTerm = pluralize('min', minutes, true)

  if (weeks > 0) {
    return weekTerm
  } else if (secondsRemaining >= DAY) {
    return dayTerm
  } else if (lowerLevel === 'days') {
    return dayTerm
  } else if (secondsRemaining >= HOUR) {
    return hourTerm
  } else if (lowerLevel === 'hours') {
    return hourTerm
  } else if (secondsRemaining >= MINUTE) {
    return minuteTerm
  }
  return '< 1 min'
}
